export enum IpoCalendarActions {
    CACHE_IPOS = "CACHE_IPOS",
    SET_QUERY_BY = "SET_QUERY_BY",
    SET_IS_LOADING = "SET_IS_LOADING"
}
